/** @jsx h */
import { h } from 'preact'
import JourneyBrand from './Brand'
import JourneyClose from './Close'
import ShareButton from './ShareButton'
import HelpButton from './HelpButton'

const JourneyHeader = props => {
  const {
    children,
    title,
    href,
    organization,
    product,
    journeyBrandDisabled,
    helpButtonDisabled,
    socialShareDisabled,
    toggleHelpTip
  } = props

  return (
    <header class='JourneyHeader'>
      {children}
      {!journeyBrandDisabled &&
        <JourneyBrand organization={organization} product={product} />}
      <div class='JourneyHeader-buttons'>
        {!helpButtonDisabled && <HelpButton toggle={toggleHelpTip} />}
        {!socialShareDisabled &&
          <ShareButton title={title} href={href} organization={organization} />}
        <JourneyClose size='large' />
      </div>
    </header>
  )
}

JourneyHeader.defaultProps = {
  product: null
}

export default JourneyHeader
